import React from "react";
import "./Process.scss";

const processSteps = [
  {
    number: "01",
    title: "Cotización inicial",
    description:
      "Escuchamos lo que necesitas, entendemos el tipo de proyecto y te orientamos con una propuesta clara según tu espacio, estilo y requerimientos.",
  },
  {
    number: "02",
    title: "Visita y levantamiento",
    description:
      "Realizamos la revisión de medidas y condiciones del lugar para asegurar que cada solución en vidrio y aluminio se adapte correctamente.",
  },
  {
    number: "03",
    title: "Fabricación a medida",
    description:
      "Desarrollamos cada elemento con materiales de calidad, cuidando precisión, funcionalidad y una excelente presentación final.",
  },
  {
    number: "04",
    title: "Instalación profesional",
    description:
      "Ejecutamos la instalación con atención al detalle, buscando un resultado limpio, seguro y visualmente impecable.",
  },
  {
    number: "05",
    title: "Entrega final",
    description:
      "Revisamos contigo el resultado final para asegurar que el proyecto cumpla con lo esperado en estética, funcionamiento y calidad.",
  },
];

const Process = () => {
  return (
    <section className="process" id="proceso">
      <div className="process__container">
        <div className="process__top">
          <span className="process__eyebrow">Proceso de trabajo</span>

          <div className="process__heading">
            <h2 className="process__title">
              Un proceso claro para desarrollar proyectos bien ejecutados
            </h2>

            <p className="process__intro">
              Trabajamos con una metodología ordenada para ofrecer soluciones en
              vidrio y aluminio con precisión, seguimiento y resultados
              profesionales desde el inicio hasta la entrega.
            </p>
          </div>
        </div>

        <div className="process__timeline">
          {processSteps.map((step, index) => (
            <article className="process__item" key={step.number}>
              <div className="process__left">
                <span className="process__number">{step.number}</span>
                {index !== processSteps.length - 1 && (
                  <span className="process__line"></span>
                )}
              </div>

              <div className="process__content">
                <h3 className="process__item-title">{step.title}</h3>
                <p className="process__item-description">{step.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;